import React from "react";
import { ExInput, Textarea } from "../../extras/Input";
import { useDispatch, useSelector } from "react-redux";
import { closeDialog } from "../../../redux/slice/dialogueSlice";
import { Box, Modal } from "@mui/material";
import Button from "../../extras/Button";

const ComplainDialog = () => {
  const dispatch = useDispatch();
  const { dialogueData } = useSelector((state) => state.dialogue);
  

  return (
  
     <Modal
          open={true}
          onClose={closeDialog}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
        <Box className="model-style">
    <div className="model-header">
          <p className="m-0">Complain Details</p>
        </div>
            <div className="model-body">
             
              <div className="row align-items-start formBody">
                <div className="col-12">
                  <Textarea
                    value={dialogueData?.details}
                    label={`Details`}
                    placeholder={`Details`}
                    readOnly={true}
                    row={5}
                  />
                </div>
                <div className="col-12 col-md-6">
                  <ExInput
                    type={`text`}
                    value={
                      dialogueData?.userId?.fname
                        ? dialogueData?.userId.fname +
                          " " +
                          dialogueData?.userId?.lname
                        : dialogueData?.expertId
                        ? dialogueData?.expertId?.fname +
                          " " +
                          dialogueData?.expertId?.lname
                        : dialogueData?.userId ? 'Salon User' : 'Salon Expert'
                    }
                    label={
                      dialogueData?.expertId
                        ? "Expert"
                        : dialogueData.userId
                        ? "User"
                        : ""
                    }
                    placeholder={
                      dialogueData?.expertId
                        ? "Expert"
                        : dialogueData.userId
                        ? "User"
                        : ""
                    }
                    readOnly={true}
                  />
                              </div>
                              
                              <div className="col-12 col-md-6">
                  <ExInput
                    type={`text`}
                    value={
                      dialogueData?.userId
                        ? dialogueData?.userId.uniqueId 
                        : dialogueData?.expertId
                        ? dialogueData?.expertId?.uniqueId 
                        : "-"
                    }
                    label={
                      dialogueData?.expertId
                        ? "Expert uniqueid"
                        : dialogueData.userId
                        ? "User uniqueid"
                        : ""
                    }
                    placeholder={
                      dialogueData?.expertId
                        ? "Expert"
                        : dialogueData.userId
                        ? "User"
                        : ""
                    }
                    readOnly={true}
                  />
                </div>
                <div className="col-12 col-md-6">
                  <ExInput
                    value={dialogueData?.date}
                    label={`Date and time of report`}
                    placeholder={`Date & Time`}
                    readOnly={true}
                  />
                              </div>
                              {dialogueData?.type === 1 &&
                                  <div className="col-12 col-md-6">
                                  <ExInput
                                    value={dialogueData?.solvedDate}
                                    label={`Solved date and time `}
                                    placeholder={`Date & Time`}
                                    readOnly={true}
                                  />
                                </div>
                              }
                {dialogueData?.image ? (
                  <div className="col-6">
                    <img
                      src={dialogueData?.image}
                      alt=""
                      draggable="false"
                      data-class={`showImage`}
                      style={{ width: "100px", height: "100px" }}
                    />
                  </div>
                ) : null}
              </div>
            </div>
            <div className="model-footer">
            <div className="m-3 d-flex justify-content-end gap-2">

              <Button
                      className={`close-model-btn`}
                      text={`Cancel`}
                      type={`button`}
                      onClick={() => dispatch(closeDialog())}
                    />
            </div>
            </div>
        </Box>

        </Modal>
       
  );
};

export default ComplainDialog;
